import "@/instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Sentry } from "@/instrument";
import { reportClientError } from "@/lib/clientErrorReporter";

// Phase 5 §13.2 — catches errors thrown outside the React render tree
// (async code, event handlers, promise rejections). React render errors are
// caught by the Sentry.ErrorBoundary below instead.
window.addEventListener("error", (event) => {
  reportClientError("WindowError", event.message, event.error?.stack);
});
window.addEventListener("unhandledrejection", (event) => {
  reportClientError("UnhandledPromiseRejection", event.reason?.message || String(event.reason), event.reason?.stack);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={<div className="p-8 text-center text-sm text-muted-foreground">Something went wrong. Please reload the page.</div>}
      onError={(error, componentStack) => reportClientError("ReactRenderError", error?.message, componentStack)}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
